import { NavLinkProps, useLocation } from 'react-router-dom';
import { PACK } from '../../../submodules/web-shared/consts/packs';
import { getCurrentPack } from '../../../submodules/web-shared/utils';

export const getExternalLinkHref = (
  pack: PACK,
  to: NavLinkProps['to'],
  location: ReturnType<typeof useLocation>
) => {

  const buildHref = (pathname?: string, search?: string) => {
    if (!pathname) return `/${pack}`;
    const path = buildPathname(pathname);
    const query = search ? `?${search}` : '';
    return `/${pack}${path}${query}`;
  };

  const locationDescriptor = typeof to === 'function' ? to(location) : to;

  if (typeof locationDescriptor === 'string') {
    return buildHref(locationDescriptor);
  }

  return buildHref(locationDescriptor.pathname, locationDescriptor.search);
};

export const getInternalLink = (
  to: NavLinkProps['to'],
  location: ReturnType<typeof useLocation>
) => {
  const locationDescriptor = typeof to === 'function' ? to(location) : to;

  if (typeof locationDescriptor === 'string') {
    return buildPathname(locationDescriptor);
  }

  return {
    ...locationDescriptor,
    pathname: locationDescriptor.pathname && buildPathname(locationDescriptor.pathname),
  };

};

export const buildPathname = (pathname: string) => pathname.startsWith('/') ? pathname : `/${pathname}`;

export const isInternalLink = (pack: string) => {
  const currentPack = getCurrentPack();
  return pack === currentPack;
};